import { useRouter } from "@/lib/router"
import { selectEmbedded } from "@/lib/storage/app-slice"
import { useAppSelector } from "@/lib/storage/hooks"
import { isAppHomeRoute } from "@/lib/utils/page"

/** True on `/home` in the main (non-embedded) app. */
export function useIsAppHomeRoute(): boolean {
  const router = useRouter()
  const embedded = useAppSelector(selectEmbedded)
  return isAppHomeRoute(router, embedded)
}
